import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useServices } from "@/app/use-services";
import type { UserPlan } from "@/lib/api/models/plan";

export const PLAN_QUERY_KEY = ["me", "plan"] as const;

/** What the person is entitled to. Refetched after anything that could change it. */
export function usePlan() {
  const { api } = useServices();
  return useQuery<UserPlan>({ queryKey: PLAN_QUERY_KEY, queryFn: () => api.fetchPlan() });
}

export function useInvalidatePlan() {
  const client = useQueryClient();
  return () => client.invalidateQueries({ queryKey: PLAN_QUERY_KEY });
}

/** Whether a call can start: free minutes left, or voice left in a subscriber's month. */
export function canTalk(plan: UserPlan): boolean {
  return plan.voice_seconds_remaining > 0;
}

/** Whether a typed question can be asked: a subscriber, or free minutes left. */
export function canType(plan: UserPlan): boolean {
  return plan.seconds_remaining === null || plan.seconds_remaining > 0;
}
